const move = (arr, from, to) => {
  const clone = [...arr];
  Array.prototype.splice.call(
    clone,
    to,
    0,
    Array.prototype.splice.call(clone, from, 1)[0]
  );

  return clone;
};

const initialState = [];

export default function (state = initialState, action) {
  switch (action.type) {
    case "FETCH_HABITS_SUCCESS":
      return [
        ...action.rows
          .filter((row) => !row.archived)
          .map((row) => ({
            isHabit: row.isHabit,
            isGroup: row.isGroup,
            id: row.id,
          })),
      ];
    case "ADD_HABIT_SUCCESS":
      const newHabit = { id: action.habit.id, isHabit: true };
      if (action.habit.position) {
        return [
          ...state.slice(0, action.habit.position),
          newHabit,
          ...state.slice(action.habit.position),
        ];
      }
      return [...state, newHabit];

    case "ADD_GROUP":
      return [...state, { id: action.group.id, isGroup: true }];
    case "INIT_DEMO":
      return action.habits;
    case "UPDATE_HABIT_AFTER_REQUEST":
      return state.map((habit) =>
        habit.id === action.oldHabit.id
          ? { ...habit, id: action.newHabit.id }
          : { ...habit, id: habit.id }
      );
    case "UPDATE_GROUP_AFTER_REQUEST":
      return state.map((group) =>
        group.id === action.oldGroup.id
          ? { ...group, id: action.newGroup.id }
          : { ...group, id: group.id }
      );
    case "DELETE_HABIT_SUCCESS":
      return state.filter(
        (row) => row.isGroup || (row.isHabit && row.id !== action.habit_id)
      );
    case "DELETE_GROUP":
      return state.filter(
        (row) => row.isHabit || (row.isGroup && row.id !== action.groupId)
      );
    case "MOVE_ROW":
      return move(state, action.from, action.to);
    case "SET_ROWS":
      return action.rows;
    case "ARCHIVE":
      return state.filter(
        (row) => row.isGroup || (row.isHabit && row.id !== action.id)
      );
    case "UNARCHIVE":
      return [...state, { isHabit: true, id: action.id }];
    case "CLEAR_DATA":
      return initialState;
    case "INIT_STATE":
      return action.state.rows || initialState;
    default:
      return state;
  }
}
